import {
  Button,
  Form,
  Input,
  Modal,
  Row,
  DatePicker,
  Typography,
  Select,
  message,
  Checkbox,
} from "antd";
import { debounce, isEmpty } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubSectorListing } from "services/redux/officeresource/business/action";
import {
  tenderSubTypeListing,
  tenderTypeListing,
} from "services/redux/Reference/Tender/action";
import {
  scopeofWorkAdd,
  scopeOfWorkListing,
  sectorListingParent,
} from "services/remanentCalls";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getRotoPaginationListNew } from "services/redux/Roto/action";
const { RangePicker } = DatePicker;
const { Option } = Select;

const RotoFilter = ({ title, filterModal, setFilterModal, advancedSearch }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [subTypeListing, setSubTypeListing] = useState([]);
  const [typeListing, setTypeListing] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  // const [selectedCategoryItem, setSelectedCategoryItem] = useState([]);

  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState([]);
  const [selectedSectorsId, setSelectedSectorsId] = useState("");
  // const [selectedSectorsItem, setSelectedSectorsItem] = useState([]);

  const [scopeSearch, setScopeSearch] = useState("");
  const [scopeTags, setScopeTags] = useState([]);
  const [compareTags, setCompareTags] = useState([]);

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 14,
    },
  };

  const { tenderTypeListingResponse, tenderSubTypeListingResponse } =
    useSelector((state) => state.tender);

  const { subSectorsListingResponse } = useSelector(
    (state) => state.businessCenter
  );

  useEffect(() => {
    if (!isEmpty(tenderTypeListingResponse)) {
      setTypeListing(tenderTypeListingResponse);
    }
  }, [tenderTypeListingResponse]);

  useEffect(() => {
    if (!isEmpty(tenderSubTypeListingResponse)) {
      setSubTypeListing(tenderSubTypeListingResponse);
    } else {
      setSubTypeListing([]);
    }
  }, [tenderSubTypeListingResponse]);

  useEffect(() => {
    if (!isEmpty(subSectorsListingResponse)) {
      setSubSectors(subSectorsListingResponse);
    } else {
      setSubSectors([]);
    }
  }, [subSectorsListingResponse]);

  useEffect(() => {
    dispatch(tenderTypeListing());
    fetchAllSector();
  }, []);

  // subcategory
  const debouncedDispatch = useCallback(
    debounce((categoryId) => {
      dispatch(tenderSubTypeListing(categoryId));
    }, 500),
    [dispatch]
  );
  useEffect(() => {
    if (!selectedCategoryId) return;

    debouncedDispatch(selectedCategoryId);
  }, [selectedCategoryId, debouncedDispatch]);

  // subsectors
  const debouncedDispatchSectors = useCallback(
    debounce((categoryId) => {
      dispatch(getSubSectorListing(categoryId));
    }, 500),
    [dispatch]
  );

  useEffect(() => {
    if (!selectedSectorsId) return;

    debouncedDispatchSectors(selectedSectorsId);
  }, [selectedSectorsId, debouncedDispatchSectors]);

  const handleSelectCategory = (values, option) => {
    if ((option !== undefined) & (option.key !== undefined)) {
      setSelectedCategoryId(option.key);
    }
  };

  const handleSectorsCategory = (values, option) => {
    if ((option !== undefined) & (option.key !== undefined)) {
      setSelectedSectorsId(option.key);
    }
  };

  const fetchAllSector = async () => {
    const resp = await sectorListingParent().catch((err) => {
      message.error("Failure");
    });

    if (resp && resp.status === 200) {
      setSectors(resp.data);
    }
  };

  const fetchScopeofWorkListing = async () => {
    const resp = await scopeOfWorkListing({ searchText: scopeSearch }).catch(
      (err) => {
        message.error("failure");
      }
    );
    if (resp && resp.status === 200) {
      setScopeTags(resp.data);
    }
  };

  const addScopeofWork = async (value, option) => {
    if (isEmpty(option)) {
      const resp = await scopeofWorkAdd(value).catch((err) => {
        message.error("Failed to add this tag");
      });
    }
  };

  function info() {
    let data = scopeSearch.replace(/\s+/g, " ").trim();
    data = scopeSearch.split(" ");

    data = data.filter((val) => !compareTags.includes(val));
    Modal.confirm({
      title: `Are you sure if you want to add new Scope of Work "${data}"`,
      okText: "Yes",
      icon: <ExclamationCircleOutlined style={{ color: "red" }} />,
      cancelText: "No",
      onOk() {
        let val = data.map((list) => ({
          name: list,
        }));
        addScopeofWork(val, "");
        form.setFieldsValue({
          scopeOfWork: !isEmpty(form.getFieldsValue().scopeOfWork)
            ? [...form.getFieldsValue().scopeOfWork.concat(data)]
            : data,
        });
      },
      onCancel() {},
    });
  }

  useEffect(() => {
    if (scopeSearch) {
      fetchScopeofWorkListing();
    } else {
      setScopeTags([]);
    }
  }, [scopeSearch]);

  return (
    <Modal
      visible={filterModal.visible}
      onCancel={() => {
        setFilterModal({
          visible: false,
          loading: false,
        });
      }}
      footer={false}
      title={
        <Typography.Paragraph style={{ margin: "auto", textAlign: "center" }}>
          {title ?? "Roto Filteer"}
        </Typography.Paragraph>
      }
    >
      <Form
        form={form}
        labelAlign="left"
        colon={false}
        autocomplete="off"
        onFinish={advancedSearch}
        {...layout}
      >
        <Form.Item
          name="scopeOfWorks"
          label="Keywords for Retrieval"
          style={{ paddingBottom: "5px" }}
        >
          <Select
            autoComplete="off"
            placeholder="Keywords for Retrieval"
            size="default"
            mode="multiple"
            getPopupContainer={(trigger) => trigger.parentNode}
            onPopupScroll={(e) => {}}
            notFoundContent={
              !isEmpty(scopeSearch)
                ? isEmpty(scopeTags) && `Create ${scopeSearch}`
                : null
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Tab") {
                setScopeTags([]);
                setScopeSearch("");
                if (isEmpty(scopeTags) && !isEmpty(scopeSearch)) {
                  info();
                }
              }
            }}
            onSearch={(e) => {
              setScopeSearch(e);
            }}
            // onSelect={(value, option) => addScopeofWork(value, option)}
            // open={dropdownscope}
            listHeight={300}
            // // onInputKeyDown={onInputKeyDown}
            onClear={() => {
              setScopeSearch("");
            }}
            style={{
              width: "100%",
            }}
          >
            {scopeTags?.map((tag) => (
              <Option value={tag.name} key={tag.id}>
                {tag.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="tenderTypes" label="Category">
          <Select
            allowClear
            size="small"
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleSelectCategory}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            {typeListing?.map((type) => (
              <Option key={type.id} value={type.tenderTypeName}>
                {type.tenderTypeName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="subTenderTypes" label="Sub Category">
          <Select
            mode="multiple"
            allowClear
            size="small"
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(values, option) => {
              const selectedData = option.map((option) => ({
                id: option.value,
                tenderTypeName: option.children,
              }));
              // setSelectedCategoryItem(selectedData);
            }}
          >
            {subTypeListing?.map((type) => (
              <Option key={type.id} value={type.tenderTypeName}>
                {type.tenderTypeName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="sectorTypes" label="Sector">
          <Select
            allowClear
            size="small"
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={handleSectorsCategory}
          >
            {sectors.map((data, i) => (
              <Option key={data.id} value={data.sectorName}>
                {data.sectorName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="subSectorTypes" label="Sub Sector">
          <Select
            mode="multiple"
            allowClear
            size="small"
            showSearch={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(value, option) => {
              const selectedData = option.map((option) => ({
                id: option.value,
                sectorName: option.children,
              }));
              // setSelectedSectorsItem(selectedData);
            }}
          >
            {subSectors?.map((data, i) => (
              <Option key={i} value={data.sectorName}>
                {data.sectorName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          valuePropName="checked"
          name="TenderCheckBox"
          initialValue={true}
        >
          <Checkbox>Tender </Checkbox>
        </Form.Item>

        <Form.Item
          valuePropName="checked"
          name="RotoOnlyCheckBox"
          initialValue={true}
        >
          <Checkbox>RotoOnly</Checkbox>
        </Form.Item>

        <Form.Item
          valuePropName="checked"
          name="ContactCompanyCheckBox"
          initialValue={true}
        >
          <Checkbox>Contact Company</Checkbox>
        </Form.Item>

        <Form.Item valuePropName="checked" name="SowAbbr" initialValue={false}>
          <Checkbox>Extended SOW Word </Checkbox>
        </Form.Item>

        <Form.Item
          name="SowSearchType"
          label="Select Search Type"
          initialValue="and"
        >
          <Select>
            <Option value="and" selected>
              And
            </Option>
            <Option value="or">OR</Option>
          </Select>
        </Form.Item>

        <Row
          style={{
            justifyContent: "right",
            paddingTop: "10px",
            marginTop: "20px !important",
            gap: "10px",
          }}
        >
          <Button
            type="ghost"
            shape="round"
            autoComplete="off"
            onClick={() => {
              form.resetFields();
            }}
          >
            Remove
          </Button>

          <Button
            type="ghost "
            shape="round"
            htmlType="submit"
            autoComplete="off"
            loading={filterModal.loading}
          >
            Search
          </Button>
        </Row>
      </Form>
    </Modal>
  );
};

export default RotoFilter;
